<template>
    <div class="grid-container case_inner" style="position:relative">
        <CaseType :caseType=content.category />
        <div class="grid-x grid-margin-x">
            <div class="cell small-12 medium-5">
                <header class="page_header">
                    <button type="button" class="back_btn show-for-small-only" @click="overlayClose">Назад</button>
                    {{ content.article.title }}
                </header>
                <div class="case_images">
                    <img :src="content.article.imageUrl">
                    <div class="fact hide-for-small-only" v-if="content.article.text_preview.length > 1">
                        {{ content.article.text_preview }}
                    </div>
                </div>
            </div>
            <div class="cell small-12 medium-7">
                <article v-if="content.article.text" v-html="content.article.text" class="case_content"></article>
                <div class="fact show-for-small-only" v-if="content.article.text_preview.length > 1">
                    {{ content.article.text_preview }}
                </div>
                <router-link :to="`/poll`" class="button open_poll">Голосовать</router-link>
                <div class="year">
                    <router-link v-if="navigation.next" :to="navigation.next" class="arr next"></router-link>
                    <router-link v-if="navigation.prev" :to="navigation.prev" class="arr prev"></router-link>
                    {{ navigation.year }}
                    <span v-if="navigation.month">{{ navigation.month }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import YearNavigation from '../components/YearNavigation'
    import CaseType from '../components/CaseType'

    export default {
        name: "Case",
        props: {
            content: {
                default: () => { return {} },
                required: true
            }
        },
        components: { YearNavigation, CaseType },
        data: () => ({}),
        computed: {
            navigation(){
                let splitDate = JSON.stringify(this.content.year).split(', ')
                let slideIdx = slides.indexOf(this.content)
                let year = splitDate[0],
                    month = splitDate[1] ? splitDate[1] : false,
                    prev = slideIdx != 1 ? `/cases/${slideIdx-1}` : false,
                    next = slideIdx < slides.length-1 ? `/cases/${slideIdx+1}` : false
                return { year, month, prev, next }
            }
        },
        created(){
            this.$root.$emit('setNav', this.content)
        },
        updated(){
            this.$root.$emit('setNav', this.content)
        },
        methods: {
            overlayClose(){
                this.$root.$emit('hideOverlay')
            }
        }
    }
</script>

<style lang="scss">
    .case_images {
        img {
            display:block; margin-bottom:$space*4;
            &:last-child { margin-bottom:0 }

            @include small {
                margin-bottom:$space;
            }
        }
    }

    .fact {
        border:1px solid #2d272f; padding:$space*1.5; font-family:$serif; text-align:right; margin-bottom:$space*4; position:relative; font-size:fsz(.9rem); width:90%;
        &:before {
            content:"Деталь"; position:absolute; top:-$space/1.3; right:$space*1.5; background:#fff; padding:0 $space; text-transform:uppercase; color:$brown; font-family:$sans-serif; font-weight:900; font-size:fsz(1rem)
        }
        @include small {
            width:100%; font-size:.8rem; margin-bottom:$space; margin-top:$space*2;
            &:before { font-size:.8rem }
        }
        @include medium {
            width:100%; font-size:.8rem; margin-bottom:$space;
            &:before { font-size:.8rem }
        }
    }

    .case_content{
        font-family:$sans-serif;
        h3 { font-weight:900; font-family:$sans-serif; margin-top:$space; color:$brown }
        p + h3 { margin-top:$space*3 }
        p { line-height:1.3 }

        @include small {
            p+h3 { margin-top:$space*1.5; }
        }

        @include medium {
            h3 { font-size:1.3rem }
        }
    }
    .case_inner .case_type {
        @include svg_text; position:fixed; left:20px;
        text { stroke:#000 }
    }

    .open_poll {
        @include golden-button;
        @include small {
            display:block; width:100%; font-size:.8rem;
        }    
    }

    .case_inner .year {
        font-size:fsz(3rem); font-family:$gorod; position:relative; display:inline-block; padding:30px 0; line-height:1; float:right; color:#908e91;
        span { position:absolute; right:68%; top:74%; font-size:1.3rem; color:transparent; -webkit-text-stroke:1px #fff; text-align:right; line-height:1.15 }

        .arr {
            position:absolute; left:50%; transform:translateX(-50%); width:0; height:0; border-style:solid; cursor:pointer;
            &:focus { outline:none }
            &.next { top:0; border-width:0 25px 20px 25px; border-color:transparent transparent $yellow transparent; animation:year_arrow_top 4s ease 0s infinite }
            &.prev { bottom:0; border-width:20px 25px 0 25px; border-color:$yellow transparent transparent transparent; animation:year_arrow_bottom 4s ease 0s infinite }
        }

        &:hover {
            .arr {
                animation-play-state:paused;
            }
        }

        @keyframes year_arrow_top {
            0%, 10%, 20%, 40%, 100% { top:-5% }
            5% { top:0 }
        }

        @keyframes year_arrow_bottom {
            0%, 10%, 20%, 40%, 100% { bottom:-5% }
            5% { bottom:0 }
        }

        @include small {
            width:100%; text-align:center; font-size:1.5rem; margin-top:$space*2;
        }

        @include medium {
            font-size:2.5rem;
        }
    }
</style>